import FingerprintJS from '@fingerprintjs/fingerprintjs'
import Cookie from 'js-cookie'
import { CookieApi } from '../api'

const isServer = () => {
  return !(typeof window != 'undefined' && window.document)
}

const setAndSendImprint = (imprintHash) => {
  Cookie.set('imprint', imprintHash, { secure: true, sameSite: 'strict' })
  const data = new FormData()
  data.append('imprint', imprintHash)
  CookieApi.imprint(data, imprintHash)
}

const getImprintHash = async () => {
  if (isServer()) {
    return Promise.resolve('')
  }

  const fingerPrint = await FingerprintJS.load()
  const { visitorId: imprintHash } = (await fingerPrint.get()) || {}

  return imprintHash
}

export const getAndSendImprintHash = async () => {
  const imprintHash = await getImprintHash()
  return setAndSendImprint(imprintHash)
}
